import { useQuery } from "@apollo/client";

import { GET_SCAN } from "./gql";

const useScan = (scanId: string | undefined) => {
  const { data, error, loading } = useQuery(GET_SCAN, {
    variables: { id: scanId ?? "" },
    skip: !scanId,
  });

  return {
    scan: data?.scan,
    error,
    loading,
  };
};

export default useScan;
